// extracted by mini-css-extract-plugin
export default {"info":"style_info__8h2UF","eventTitle":"style_eventTitle__I8x-i","dateInscription":"style_dateInscription__xTo4x","section":"style_section__a6Hxz"};